import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4v20h16V2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"
}), 'PhotoAlbumSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PhotoAlbumSharp.js
// module id = 5430
// module chunks = 2